module.exports = __webpack_public_path__ + "img/idea-vision-expert-icon.8aec54b6.svg";